import { React, useEffect, useState, useRef } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Skeleton from '@mui/material/Skeleton';
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService'
import Button from '@mui/material/Button';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Collapse from '@mui/material/Collapse';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DownloadIcon from '@mui/icons-material/Download';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';



export default function Flyer(props) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [nameType, setNameType] = useState('FIRST');
    const [size, setSize] = useState('Small');
    const [isExpanded, setIsExpanded] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const includeImage = useRef(false);


    useEffect(() => {
        loadPreview(nameType, size); // only called once
    }, []);

    function loadPreview(nameOption, sizeOption) {
        let extras = [];
        if (includeImage.current) {
            extras.push('images');
        }
        let postData = {
            flyerName: props.flyerName,
            tag: props.tag,
            size: sizeOption,
            extras: extras
        }
        TokenService.customerPost(postData, 'Charity_DownloadFlyer')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    setImagePreview("data:image/png;base64," + jsonData.Flyer);
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function handleDownloadFlyer() {
        let extras = [];
        if (includeImage.current) {
            extras.push('images');
        }
        let postData = {
            flyerName: props.flyerName,
            tag: props.tag,
            size: size,
            extras: extras
        }
        TokenService.customerPost(postData, 'Charity_DownloadFlyer')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    downloadImage(jsonData.Flyer, 'Sipzee_Flyer.png');


                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function downloadImage(base64Image, fileName) {
        // Convert Base64 to Uint8Array
        var byteCharacters = atob(base64Image);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);

        // Create a Blob from the Uint8Array
        var blob = new Blob([byteArray], { type: 'image/png' });

        // Create a URL for the Blob
        var url = URL.createObjectURL(blob);

        // Create a temporary anchor element
        var link = document.createElement('a');
        link.href = url;
        link.download = fileName;

        // Trigger the download
        link.click();

        // Clean up the URL and anchor element
        URL.revokeObjectURL(url);
    }

    function handleImageOptionChange(event) {
        includeImage.current = event.target.checked;
        loadPreview(event.target.value, 'Small');
    }

    function handleToggleExpand() {
        setIsExpanded(!isExpanded);
    }





    return (
        <Card>
            <div style={{ fontWeight: 'bold', fontSize: 22, border: '1px solid #efefef', marginBottom: '5px' }}>
                {props.displayName}
            </div>
            {imagePreview == null ?
                <Skeleton variant="rectangular" width={350} height={457} />
                :

                <CardMedia
                    component="img"
                    alt="flyer"

                    image={imagePreview}
                />
            }

            <CardContent>
                <Collapse in={isExpanded} timeout='auto' unmountOnExit>
                    <div style={{ fontStyle: 'italic', fontSize: '10pt' }}>
                        * QR Code allows customers to request you.
                    </div>

                    <div style={{ marginTop: '25px' }}>
                        <FormControl>
                            <FormLabel id="demo-controlled-radio-buttons-group">Image Size</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={size}
                                onChange={(e) => setSize(e.target.value)}
                            >
                                <FormControlLabel value="Small" control={<Radio />} label="For Digital Sharing (smaller)" />
                                <FormControlLabel value="Full" control={<Radio />} label="Printable (larger)" />
                            </RadioGroup>
                        </FormControl>
                    </div>
                    {props.hasImages ?
                        <div style={{ marginTop: '25px' }}>
                            <FormGroup style={{marginLeft:'35px'} }>
                                <FormControlLabel control={<Checkbox
                                    checked={includeImage.current}
                                    onChange={(e) => handleImageOptionChange(e)}
                                />} label="Include Image" />
                            </FormGroup>
                            
                        </div>
                    :null
                    }
                    <div style={{ marginTop: '25px', display: 'flex', justifyContent: 'space-between' }}>
                        <Button variant='outlined' onClick={() => handleDownloadFlyer()}>Download <DownloadIcon /></Button>
                       
                    </div>
                </Collapse>
            </CardContent>
            <div style={{ backgroundColor: 'var(--sipzee-gray-3)', height: '35px' }} onClick={() => handleToggleExpand()}>
                {isExpanded ?
                    <div>
                        <div style={{ fontSize: '8pt', fontStyle: 'italic' }}>show less</div>
                        <ExpandLessIcon />
                    </div>
                    :
                    <div>
                        <div style={{ fontSize: '8pt', fontStyle: 'italic' }}>show more</div>
                        <ExpandMoreIcon />
                    </div>
                }
            </div>
            
        </Card>
    )
}